import api from '@/api';

export async function sendMail(info) {
    try{
        const response = await api.post(`/admin/mail`, info);
        return{
            mail: response.data,
            error: null
        }
    }catch(err){
        console.error("Error fetching company information:", err);
        return{
            mail: null,
            error: "We couldn´t send the mail"
        }
    }
}